import { render, staticRenderFns } from "./DeleteTaskPopup.vue?vue&type=template&id=20e398d9&scoped=true&"
import script from "./DeleteTaskPopup.vue?vue&type=script&lang=ts&"
export * from "./DeleteTaskPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteTaskPopup.vue?vue&type=style&index=0&id=20e398d9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e398d9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20e398d9')) {
      api.createRecord('20e398d9', component.options)
    } else {
      api.reload('20e398d9', component.options)
    }
    module.hot.accept("./DeleteTaskPopup.vue?vue&type=template&id=20e398d9&scoped=true&", function () {
      api.rerender('20e398d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeleteTaskPopup.vue"
export default component.exports